import React, { useContext, useEffect, useState } from "react";
import {
  DisbursementModalityContentForm,
  DisbursementModalitySubtitleForm,
  DisbursementModalityErrorMessage
} from "./styles";
import { H5 } from '../../../components/Typography/styles';
import { SecondaryLargeButton } from '../../../components/Buttons/styles';
import InputRadioButton from "../../../components/InputRadioButton";
import { accountTypes, meansOfDisbursementStepsCheckboxFields } from "../../../helpers/enum";
import { MeansOfDisbursementContext } from "../../../store";
import colors from "../../../assets/styles/colors";
import Select from '../../../components/Select';
import InputDefault from '../../../components/InputDefault';
import FormTemplate from '../../../components/FormTemplate';
import Loader from '../../../components/Loader';
import { useForm, Controller } from "react-hook-form";
import SearchField from "../../../components/SearchField";
import { meansOfDisbursementSteps } from '../../../helpers/enum';
import { Form, FormFooter, FormRow, FormRowInvisible } from "../../../components/FormTemplate/styles";
import { default as MeansOfDisbursementTypes } from '../../../store/MeansOfDisbursement/types';
import { getMeansOfDisbursementById } from '../../../services/meansOfDisbursement';
import { getFinancialEntities } from "../../../services/financialCommitments";
import { getCities } from "../../../services/cities";
import { getStates } from "../../../services/states";
import { useHistory, useLocation } from 'react-router-dom';
import { clientTypes } from '../../../helpers/enum';
import { meansOfDisbursementRegister } from '../../../services/meansOfDisbursement';
import { getPiloto } from "../../../services/desk";
import { skipException } from "../../../services/exceptions";

const DisbursementModalityPage = ({ setActiveStep, setLastStep, idSimulation }) => {
  const history = useHistory();
  const location = useLocation();
  const { meansOfDisbursement, setMeansOfDisbursement } = useContext(MeansOfDisbursementContext);
  const { control, setValue, clearErrors, register, handleSubmit, errors, watch } = useForm({ defaultValues: meansOfDisbursement.disbursementModality });
  const [financialEntities, setFinancialEntities] = useState([]);
  const [showFinancialEntities, setShowFinancialEntities] = useState(false);
  const [showCity, setShowCity] = useState(false);
  const [showState, setShowState] = useState(false);
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const fields = watch();
  const actividadesNoActivas = ['PENSIONADO', 'JUBILADO'];

  async function initializeStateComponent() {
    try {
      if (meansOfDisbursement.disbursementModality.state) {
        setValue('state', meansOfDisbursement.disbursementModality.state.nombre)
      }

      if (meansOfDisbursement.disbursementModality.city) {
        setValue('city', meansOfDisbursement.disbursementModality.city.nombre)
      }

      const financialEntitiesResponse = await getFinancialEntities();
      const statesResponse = await getStates();
      setFinancialEntities(financialEntitiesResponse.data);
      setStates(statesResponse.data);

      const meansOfDisbursementResponse = await getMeansOfDisbursementById(location.idCredit);

      await setMeansOfDisbursement({
        type: MeansOfDisbursementTypes.SET_MEANS_OF_DISBURSEMENT,
        meansOfDisbursement: meansOfDisbursementResponse.data
      })

      setIsLoading(false);
      setCreditToStore(meansOfDisbursementStepsCheckboxFields[0]);
    } catch (error) {
      console.log(error.response)
    }
  }

  async function setSelectedState(state) {
    try {
      setIsLoading(true);
      const cities = await getCities(state.id);
      setCities(cities.data);

      setValue('state', state.nombre);
      setMeansOfDisbursement({
        type: MeansOfDisbursementTypes.SET_SELECTED_STATE,
        state
      });

      if (fields.city) {
        setValue('city', '');
        setMeansOfDisbursement({
          type: MeansOfDisbursementTypes.SET_SELECTED_CITY,
          city: {}
        });

        setShowCity(false);
      }

      setIsLoading(false);
      setShowState(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error.response)
    }
  }

  function setSelectedCity(city) {
    setValue('city', city.nombre);
    setMeansOfDisbursement({
      type: MeansOfDisbursementTypes.SET_SELECTED_CITY,
      city
    });

    setShowCity(false);
  }

  function searchInState(e) {
    setShowState(true);
    setShowCity(false);
    const filtered = states.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredStates(filtered);
  }

  function searchInCities(e) {
    setShowCity(true);
    setShowState(false);
    const filtered = cities.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredCities(filtered);
  }

  function selectFinancialEntitie(financialEntitie) {
    setValue("financialEntitie", financialEntitie);
    clearErrors("financialEntitie", {});

    setMeansOfDisbursement({
      type: MeansOfDisbursementTypes.SET_FINANCIAL_ENTITIE,
      financialEntitie: financialEntitie
    })
  }


  function verifyCheckboxModalidad(checkbox) {
    return (
      meansOfDisbursement.disbursementModality.modalidad.id === checkbox.id
    );
  }

  function verifyCheckboxAccountType(accountType) {
    return (
      meansOfDisbursement.disbursementModality.accountType.id === accountType.id
    );
  }

  function setCreditToStore(credit) {
    setMeansOfDisbursement({
      type: MeansOfDisbursementTypes.SET_MODALIDAD,
      modalidad: credit,
    });

    if (credit.id !== meansOfDisbursementStepsCheckboxFields[0].id) {
      selectFinancialEntitie({
        nombre: ''
      });
      setSelectedCity('');
      setSelectedState('');
      setAccountType({})
    }
  }

  function setAccountType(accountType) {
    setMeansOfDisbursement({
      type: MeansOfDisbursementTypes.SET_ACCOUNT_TYPE,
      accountType: accountType,
    });
  }

  async function setCompleteStep(data) {
    try {
      setMeansOfDisbursement({
        type: MeansOfDisbursementTypes.SET_DISBURSEMENT_MODALITY_DATA,
        data
      })
      const req = {
        idCredito: location.idCredit,
        numeroCuenta: data.numeroCuenta, /* Como viene de un inputDefault y no guarda el dato, lo saco de data y no de meansOfDisbursement.disbursementModality */ 
        idTipoCuenta: meansOfDisbursement.disbursementModality.accountType.id, 
        idDepartamento: meansOfDisbursement.disbursementModality.state.id,
        idCiudad: meansOfDisbursement.disbursementModality.city.id,
        idModalidadDesembolso: meansOfDisbursement.disbursementModality.modalidad.id,
        idTipoCliente: "Producto Reportado",
        idEntidadFinanciera: meansOfDisbursement.disbursementModality.financialEntitie.id,
        subCanal: "WEB"
      }
      await meansOfDisbursementRegister(req);
      
      
      const isPilotoCambioEstados = await getPiloto(meansOfDisbursement.credit.idOficina);
      if(isPilotoCambioEstados.data.isNuevaUbicacionSimulador){
        const data = {
          idCredito: location.idCredit,
        }
        skipException(data);
        history.push({
          pathname: '/admin/ap-secure',
          idCredit: location.idCredit,
        });
      }else{
        history.push({
          pathname: '/admin/data-solicitation',
          idCredit: location.idCredit,
          client: {
            id: meansOfDisbursement.solicitation.cliente.id,
            identification: meansOfDisbursement.solicitation.cliente.identificacion,
            identificationType: meansOfDisbursement.solicitation.cliente.tipoIdentificacion
          }
        });
      }
    } catch (error) {
      console.log(error.response)
    }
  }

  function isClienteActivo(credito) {
    return credito &&
      !actividadesNoActivas.includes(credito.actividad && credito.actividad.toUpperCase() || "")
      || null;
  }

  useEffect(() => {
    initializeStateComponent();
    setIsLoading(false);
  }, [])

  return (
    <FormTemplate
      idForm="disbursement-modality-step-lage"
      activeStep="1/1"
      stepLabel="Selecciona la modalidad"
      idCredito={location.idCredit}>
      <Form onSubmit={handleSubmit(setCompleteStep)}>
        <InputRadioButton
          onClick={() =>
            setCreditToStore(meansOfDisbursementStepsCheckboxFields[0])
          }
          checked={verifyCheckboxModalidad(meansOfDisbursementStepsCheckboxFields[0])}
          value={meansOfDisbursementStepsCheckboxFields[0].name}
        />
        {
          !isClienteActivo(meansOfDisbursement.credit) && (
            <InputRadioButton
              onClick={() =>
                setCreditToStore(meansOfDisbursementStepsCheckboxFields[1])
              }
              checked={verifyCheckboxModalidad(meansOfDisbursementStepsCheckboxFields[1])}
              value={meansOfDisbursementStepsCheckboxFields[1].name}
            />)
        }
        {meansOfDisbursement.disbursementModality.modalidad.id === meansOfDisbursementStepsCheckboxFields[0].id && (
          <DisbursementModalityContentForm>
            <H5 color={colors.textPrimary}> Datos para desembolso</H5>
            <DisbursementModalitySubtitleForm>Tipo de cuenta</DisbursementModalitySubtitleForm>
            <FormRow col="2">
              <InputRadioButton
                onClick={() => setAccountType(accountTypes[0])}
                checked={verifyCheckboxAccountType(accountTypes[0])}
                value={accountTypes[0].name}
              />
              <InputRadioButton
                onClick={() => setAccountType(accountTypes[1])}
                checked={verifyCheckboxAccountType(accountTypes[1])}
                value={accountTypes[1].name}
              />
            </FormRow>
            <FormRow col="2">
              <Select
                error={errors.financialEntitie}
                setShow={setShowFinancialEntities}
                show={showFinancialEntities}
                defaultValue={meansOfDisbursement.disbursementModality.financialEntitie.nombre}
                setSelected={selectFinancialEntitie}
                list={financialEntities}
                placeholder="Seleccionar..."
                label="Entidad Financiera"
                name="financialEntitie"
                id="financialEntitie"
                register={register({ required: "Este dato es obligatorio" })} />
              <Controller
                type="number"
                as={InputDefault}
                control={control}
                label="Número de cuenta"
                name="numeroCuenta"
                id="numeroCuenta"
                register={register({ required: "Este dato es obligatorio" })}
                error={errors.numeroCuenta}
                value={meansOfDisbursement.disbursementModality.numeroCuenta} />
            </FormRow>
            <FormRow col="2">
              <SearchField
                label="Departamento de la cuenta de ahorros o CTE."
                name="state"
                id="state"
                show={showState}
                list={filteredStates}
                defaultValue={meansOfDisbursement.disbursementModality.state.nombre}
                selectField={setSelectedState}
                searchInList={searchInState}
                register={register({ required: "Este dato es obligatorio" })}
                placeholder="Buscar..."
                error={errors.state} />

              <SearchField
                label="Ciudad de la cuenta de ahorros o CTE."
                name="city"
                id="city"
                show={showCity}
                list={filteredCities}
                defaultValue={meansOfDisbursement.disbursementModality.city.nombre}
                selectField={setSelectedCity}
                searchInList={searchInCities}
                error={errors.city}
                register={register({ required: "Este dato es obligatorio" })}
                placeholder="Buscar..."
                disabled={!meansOfDisbursement.disbursementModality.state} />
            </FormRow>
          </DisbursementModalityContentForm>
        )}
        <FormFooter justify="flex-end">
          <SecondaryLargeButton type="submit">Siguiente</SecondaryLargeButton>
        </FormFooter>
      </Form>
      {isLoading && <Loader />}
    </FormTemplate>
  );
};

export default DisbursementModalityPage;
